module.exports = __webpack_public_path__ + "img/成功@3x.5c145614.png";